import { useLocation } from "react-router-dom";

/**
 * Custom hook to get the value of a query parameter.
 * @param key The name of the query parameter to retrieve.
 * @returns The value of the query parameter or null if not found.
 */
export const useQueryParam = (key: string): string | null => {
  const location = useLocation(); // Access the current URL
  const searchParams = new URLSearchParams(location.search);

  // Return the value of the specified query parameter
  return searchParams.get(key);
};
